<template>
  <div class="ny-contactus">
    <div class="centent">
      <h2 class="center">留下您的联系方式，我们的客户经理将与您联系</h2>
      <p class="center">
        如果您希望进一步了解商务旅行服务的相关信息，或加入我们企业差旅客户的行列，请留下您的联系方式
      </p>
      <div class="content">
        <div class="flex-row item">
          <input
            type="text"
            maxlength="50"
            placeholder="联系人"
            value=""
            v-model="linkman"
          />
          <input
            type="text"
            maxlength="50"
            placeholder="联系电话"
            value=""
            v-model="linkPhone"
          />
        </div>
        <div class="flex-row item">
          <input
            type="text"
            maxlength="50"
            placeholder="公司全称"
            value=""
            v-model="fullname"
          />
          <input
            type="text"
            maxlength="5"
            placeholder="所属行业"
            v-model="industry"
          />
        </div>
        <div class="flex-row item">
          <input
            type="text"
            maxlength="50"
            placeholder="公司邮箱"
            value=""
            v-model="email"
          />
        </div>
        <div class="flex-row item">
          <div class="btn" @click="sumbit()">立即咨询</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { linkOur } from "../api/url";
export default {
  name: "consult",
  data() {
    return {
      linkman: "",
      linkPhone: "",
      fullname: "",
      email: "",
      industry: "",
    };
  },
  created() {},
  computed: {},
  methods: {
    // 提交数据
    sumbit() {
      let phone =/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.linkman == "") {
        this.$toast({
          text: "请输入联系人",
          type: "info",
          duration: 1000,
        });
        return false;
      }else if (this.linkPhone == "") {
        this.$toast({
          text: "请输入联系电话",
          type: "info",
          duration: 1000,
        });
        return false;
      }else if(!phone.test(this.linkPhone)){
        this.$toast({
          text: "请输入正确联系电话",
          type: "info",
          duration: 1000,
        });
        return false;
      } else if (this.fullname == "") {
        this.$toast({
          text: "请输入公司全称",
          type: "info",
          duration: 1000,
        });
        return false;
      } 
      return linkOur({
        linkman: this.linkman,
        linkPhone: this.linkPhone,
        fullname: this.fullname,
        email: this.email,
        industry: this.industry,
        compId:'5e51deb47c3742c1ad1b78abf6600910'
      }).then((res) => {
          if(res.errCode === '1'){
            this.$toast({
              text: "您的信息已记录，稍后会有专人联系您！",
              type: "info",
              duration: 1000,
            });
          }
        }).catch((error) => {
          this.$toast({
          text:error,
          type: "info",
          duration: 1000,
        });
      });
    },
  },
  mounted() {},
  destroy() {},
};
</script>
<style lang="less" scoped>
.ny-contactus {
  width: 100%;
  padding: 50px 0;
  background: url("../assets/contactus.png") 50%;
  background-size: 100% 100%;
  .centent {
    width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
    h2 {
      font-size: 2rem;
      color: #fff;
      font-weight: 700;
    }
    p {
      font-size: 0.9rem;
      color: #fff;
      margin: 20px 0 40px;
    }
    .content {
      .item {
        width: 600px;
        margin: 0 auto 30px;
        input {
          width: 280px;
          background: #fff;
          margin-right: 20px;
          padding-left: 20px;
          font-size: 0.9rem;
          border-radius: 5px;
          height: 40px;
          line-height: 40px;
          outline: none;
        }
        .btn {
          width: 280px;
          font-size: 0.9rem;
          color: #fff;
          background: #d82a1f;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>